import classNames from "classnames";
import DateTimeInput from "../../../../../form/DateTimeInput";
import React from "react";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems} = props;
    const dateFields = ["issuedate", "transactiondate", "deadline", "accountdate"];
    return (hidden || []).indexOf("accountdate") === -1 && <div className={classNames("col-sm-" + (propsTop.col || (12 / (dateFields.length-(hidden || []).filter((h) => dateFields.indexOf(h) !== -1).length))))}>
        <DateTimeInput name="accountdate"
                   label="Elszámolás dátuma"
                   isClearable={propsTop.isClearable}
                   {...props.getProps("accountdate")}
                   value={props.getValue("accountdate")}
                   showTime={false} saveChanges={props.setFieldValue}/>
    </div>;
}